import { Button, CardHeader, FormControl, FormControlLabel, FormLabel, Grid, Paper, Radio, RadioGroup, TextField } from "@mui/material";
import axios from "axios";
import { createForm } from "rc-form";
import * as React from "react";
import cookie from "react-cookies";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";
import { DefaultProps } from "../LayoutWrapper";

interface ToolsWrappedState {
    changingPassword: boolean;
}

class UserSettingsWrapped extends React.Component<DefaultProps, ToolsWrappedState> {

    constructor(props) {
        super(props);

        this.state = {
            changingPassword: false,
        };

        document.title = Helpers.documentTitle("Settings");
    }

    saveSettings = () => {
        const self = this;

        this.props.form.validateFields((err, values) => {
            if (err) {
                return;
            }

            const settings: any = Object.keys(values).reduce((list, key) => {
                if (key.includes("settings_")) {
                    list[key.split("settings_")[1]] = values[key];
                }

                return list;
            }, {});

            axios.post(`${Config.getInstance.apiUrl}/api/users/update/settings`, {
                user_id: self.props.activeUser.userId,
                settings
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            })
            .then(_ => {
                this.props.switchMode(settings.theme);

                PopupMessage.success("Settings saved!");
            })
            .catch(_ => {
                PopupMessage.error("Couldn't save settings!");
            });
        });
    }

    changePassword = () => {
        const self = this;

        this.props.form.validateFields((err, values) => {
            if (err) {
                return;
            }

            this.setState({ changingPassword: true }, () => {
                axios.post(`${Config.getInstance.apiUrl}/api/users/change_password`, {
                    current_password: values.current_password,
                    new_password: values.new_password,
                    new_password_again: values.new_password_again,
                    user_id: self.props.activeUser.userId,
                }, {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                    },
                }).then((result) => {
                    cookie.remove("brl-target-app");
                    cookie.remove("brl-session-token");
                    cookie.remove("active-env");

                    self.props.resetAppState();
                }).catch(_ => {
                    PopupMessage.error("Something went wrong!");
                });
            });
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <div className="contentPadding">
                <Paper className="root" elevation={0}>
                    <CardHeader title="Settings" />

                    <Grid container spacing={2} style={{padding: 20}}>
                        <Grid item xs={12} spacing={2}>
                            <FormControl>
                                {getFieldDecorator("settings_full_name", {
                                    initialValue: this.props.activeUser.fullName,
                                })(
                                    <TextField label="Name"/>
                                )}

                            </FormControl>
                        </Grid>

                        <Grid item xs={12} spacing={2}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Theme</FormLabel>
                                {getFieldDecorator("settings_theme", {
                                    initialValue: this.props.mode,
                                })(
                                    <RadioGroup row>
                                        <FormControlLabel value="dark" control={<Radio />} label="Dark" />
                                        <FormControlLabel value="light" control={<Radio />} label="Light" />
                                    </RadioGroup>
                                )}

                            </FormControl>
                        </Grid>

                        <Grid item xs={12} spacing={2}>
                            <Button
                                disableElevation
                                color="primary"
                                size="small"
                                variant="contained"
                                onClick={this.saveSettings}
                            >
                                Save changes
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>

                <Paper className="root" elevation={0}>
                    <CardHeader title="Change password" />

                    <Grid container spacing={2} style={{padding: 20}}>
                        <Grid item xs={12} spacing={2}>
                            <FormControl style={{ width: "100%" }}>

                                {getFieldDecorator("current_password")(
                                    <TextField style={{ width: "100%" }} type="password" size="small" label="Current password"/>,
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} spacing={2}>
                            <FormControl style={{ marginTop: 15, width: "100%" }}>

                                {getFieldDecorator("new_password")(
                                    <TextField style={{ width: "100%" }} type="password" size="small" label="New password"/>,
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} spacing={2}>
                            <FormControl style={{ marginTop: 15, width: "100%" }}>

                                {getFieldDecorator("new_password_again")(
                                    <TextField style={{ width: "100%" }} type="password" size="small" label="Reenter new password"/>,
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} spacing={2}>
                            <Button
                                disableElevation
                                color="primary"
                                onClick={this.changePassword}
                                size="small"
                                variant="contained"
                            >
                                Change password
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        );
    }
}

export const UserSettings = createForm()(UserSettingsWrapped);
